<template>
  <!-- 订单详情 -->
  <div class="internal-details" v-if="dialogVisible">
    <el-dialog
      center
      title="商品发货详情"
      width="90%"
      custom-class="order-dialog"
      :visible.sync="dialogVisible"
      @close="$emit('update:visible', false)"
    >
      <div>
        <div class="ship-radio">
          <p>快递公司选择:</p>
          <div>
            <el-radio-group v-model="expressCompanyEnum">
              <el-radio
                size="medium"
                border
                v-for="(option, index) in expressOptions"
                :key="index"
                :label="option.expressCompany"
                >{{ getCompanyName(option.expressCompany) }}</el-radio
              >
            </el-radio-group>
            <div class="ship-btn">
              <el-button
                type="primary"
                @click="handleAppointmentConfirm()"
                size="small"
                >无面单寄件发货</el-button
              >
              <el-button
                type="success"
                @click="handleElectronicConfirm()"
                size="small"
                >电子面单寄件发货</el-button
              >
              <el-button type="warning" @click="handleEditFill()" size="small"
                >手动填写单号</el-button
              >
              <el-button type="danger" @click="handleReship()" size="small"
                >订单补发</el-button
              >
              <el-button type="info" @click="handleReshipList()" size="small"
                >订单补发历史</el-button
              >
            </div>
          </div>
        </div>
        <div class="ship-table">
          <p>发货商品选择(可多选、可一个或多个快递发货):</p>
          <el-table
            :data="shipmentData"
            style="width: 100%"
            tooltip-effect="dark"
            ref="multipleTable"
            @selection-change="handleSelectionChange"
            :header-cell-style="{ 'text-align': 'center' }"
            :cell-style="{ 'text-align': 'center' }"
          >
            <el-table-column
              type="selection"
              width="55"
              :selectable="isRowSelectable"
            ></el-table-column>
            <el-table-column
              label="订单编号"
              prop="orderSn"
              width="160"
            ></el-table-column>
            <el-table-column
              prop="paySn"
              label="支付订单号"
              width="190"
            ></el-table-column>
            <el-table-column
              prop="productName"
              label="商品名称"
              width="150"
              :show-overflow-tooltip="true"
            ></el-table-column>
            <el-table-column prop="productPic" label="商品图片" width="120">
              <template v-slot:default="scope">
                <el-image
                  style="width: 50px; height: 50px"
                  :src="scope.row.pic"
                />
              </template>
            </el-table-column>
            <el-table-column prop="quantity" label="数量"></el-table-column>
            <el-table-column prop="deliverySn" label="快递单号" width="180">
              <template v-slot:default="scope">
                <el-link
                  :underline="false"
                  type="primary"
                  v-for="(item, index) in scope.row.deliverySn
                    ? scope.row.deliverySn.split(',')
                    : []"
                  ::key="index"
                  @click="expressDetail(item)"
                >
                  {{ item }}
                </el-link>
              </template>
            </el-table-column>
            <el-table-column
              prop="deliveryCompany"
              label="快递公司名称"
              width="180"
            >
              <template v-slot:default="scope">
                <p>
                  {{ getCompanyName(scope.row.deliveryCompany) }}
                </p>
              </template>
            </el-table-column>
            <el-table-column
              prop="supplierId"
              label="供应商"
              :formatter="formatSupplierName"
              width="120"
            ></el-table-column>
            <el-table-column label="操作" width="220" fixed="right">
              <template slot-scope="scope">
                <!-- deliveryType: 0预约上门 1电子面单 2手动填单 -->
                <!-- true=Lodop 直接打印；false=浏览器面单预览弹框 -->
                <el-button
                  v-if="scope.row.deliveryType == 1"
                  size="medium"
                  @click="handleEdit(scope.row, true)"
                  type="text"
                  >补打面单</el-button
                >
                <el-button
                  v-if="scope.row.deliveryType == 1"
                  size="medium"
                  @click="handleEdit(scope.row, false)"
                  type="text"
                  >面单预览打印</el-button
                >
                <el-button
                  v-if="canCancelShipment(scope.row)"
                  size="medium"
                  @click="handleCancle(scope.row)"
                  type="text"
                  >取消寄件</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </el-dialog>
    <!-- 面单 PDF 预览（浏览器内置 PDF 查看器） -->
    <el-dialog
      title="面单预览"
      :visible.sync="pdfPreviewVisible"
      width="860px"
      top="3vh"
      append-to-body
      custom-class="waybill-preview-dialog"
      @closed="onPdfPreviewClosed"
    >
      <iframe
        v-if="pdfPreviewVisible && previewSrc"
        ref="pdfPreviewFrame"
        :src="previewSrc"
        class="waybill-preview-frame"
        title="面单预览"
      ></iframe>
      <p v-else class="waybill-preview-empty">暂无可预览的面单</p>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="pdfPreviewVisible = false"
          >关 闭</el-button
        >
        <el-button size="small" @click="openPdfInNewTab">新窗口打开</el-button>
        <el-button
          type="primary"
          size="small"
          :loading="pdfPrintLoading"
          @click="printBrowserPdf"
          >打 印</el-button
        >
      </span>
    </el-dialog>
    <!-- 物流状态弹框 -->
    <el-drawer
      title="物流轨迹"
      :visible.sync="drawer"
      :before-close="handleClose"
    >
      <p style="color: red">{{ preDetail.Reason }}</p>
      <el-timeline :reverse="true">
        <el-timeline-item
          v-for="(activity, index) in preDetail.Traces"
          :key="index"
          :timestamp="activity.AcceptTime"
          >{{ activity.AcceptStation }}</el-timeline-item
        >
      </el-timeline>
    </el-drawer>
    <el-dialog
      custom-class="mall-begin-dialog"
      title="手动填写单号"
      :visible.sync="dialogVisibleFill"
      width="30%"
      center
    >
      <el-form label-width="120px" size="small">
        <el-form-item label="快递单号:">
          <el-input v-model="orderFillDeliverySn"></el-input>
        </el-form-item>
        <el-form-item label="发货人手机号:">
          <el-input
            v-model="orderFillSenderPhone"
            placeholder="选填"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleFill = false" size="small"
          >取 消</el-button
        >
        <el-button type="primary" @click="handleDialogFill" size="small"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <!-- 订单补发 -->
    <el-dialog
      custom-class="mall-begin-dialog"
      title="订单补发"
      :visible.sync="dialogVisibleReship"
      width="480px"
      center
      append-to-body
    >
      <el-form label-width="110px" size="small">
        <el-form-item label="发货方式:" required>
          <el-radio-group v-model="reshipForm.shipmentMode">
            <el-radio label="APPOINTMENT">无面单</el-radio>
            <el-radio label="ELECTRONIC">电子面单</el-radio>
            <el-radio label="MANUAL">手动填写单号</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          v-if="reshipForm.shipmentMode === 'MANUAL'"
          label="快递单号:"
          required
        >
          <el-input
            v-model="reshipForm.expressNo"
            placeholder="请输入快递单号"
          ></el-input>
        </el-form-item>
        <el-form-item label="补发原因:" required>
          <el-input
            type="textarea"
            :rows="3"
            v-model="reshipForm.reason"
            placeholder="请填写补发原因"
            maxlength="200"
            show-word-limit
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleReship = false" size="small"
          >取 消</el-button
        >
        <el-button
          type="primary"
          size="small"
          :loading="reshipSubmitting"
          @click="handleReshipConfirm"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <!-- 订单补发历史 -->
    <el-dialog
      title="订单补发历史"
      :visible.sync="dialogVisibleReshipList"
      width="90%"
      top="5vh"
      append-to-body
      custom-class="reship-history-dialog"
    >
      <el-table
        v-loading="reshipListLoading"
        :data="reshipListData"
        style="width: 100%"
        :header-cell-style="{ 'text-align': 'center' }"
        :cell-style="{ 'text-align': 'center' }"
        max-height="560"
      >
        <el-table-column type="expand">
          <template slot-scope="scope">
            <el-table
              :data="scope.row.items || []"
              size="mini"
              border
              style="width: 100%"
            >
              <el-table-column
                prop="productName"
                label="商品名称"
                min-width="160"
              ></el-table-column>
              <el-table-column
                prop="quantity"
                label="补发数量"
                width="100"
              ></el-table-column>
              <el-table-column
                prop="orderItemId"
                label="子订单ID"
                width="120"
              ></el-table-column>
              <el-table-column
                prop="supplierId"
                label="供应商"
                width="120"
                :formatter="formatSupplierName"
              ></el-table-column>
              <el-table-column
                prop="createTime"
                label="创建时间"
                width="170"
              ></el-table-column>
            </el-table>
            <p v-if="!(scope.row.items && scope.row.items.length)" class="reship-empty">
              暂无补发商品明细
            </p>
          </template>
        </el-table-column>
        <el-table-column prop="id" label="补发ID" width="90"></el-table-column>
        <el-table-column
          prop="orderSn"
          label="订单编号"
          width="160"
        ></el-table-column>
        <el-table-column label="发货方式" width="110">
          <template slot-scope="scope">
            {{ formatShipmentMode(scope.row.shipmentMode) }}
          </template>
        </el-table-column>
        <el-table-column label="快递公司" width="120">
          <template slot-scope="scope">
            {{
              getCompanyName(
                (scope.row.express && scope.row.express.expressCompany) ||
                  scope.row.expressCompany,
              )
            }}
          </template>
        </el-table-column>
        <el-table-column label="快递单号" min-width="160">
          <template slot-scope="scope">
            <el-link
              v-if="getReshipExpressNo(scope.row)"
              type="primary"
              :underline="false"
              @click="expressDetail(getReshipExpressNo(scope.row))"
            >
              {{ getReshipExpressNo(scope.row) }}
            </el-link>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="reason"
          label="补发原因"
          min-width="140"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column label="创建状态" width="100">
          <template slot-scope="scope">
            {{ formatCreateStatus(scope.row.createStatus) }}
          </template>
        </el-table-column>
        <el-table-column
          prop="operatorName"
          label="操作人"
          width="100"
        ></el-table-column>
        <el-table-column
          prop="createTime"
          label="补发时间"
          width="170"
        ></el-table-column>
        <el-table-column
          prop="failureReason"
          label="失败原因"
          min-width="120"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column label="操作" width="100" fixed="right">
          <template slot-scope="scope">
            <el-button
              v-if="getReshipPrintTemplate(scope.row)"
              type="text"
              size="medium"
              @click="
                extractPdfUrlFromHtml(getReshipPrintTemplate(scope.row))
              "
              >补打面单</el-button
            >
            <span v-else>-</span>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisibleReshipList = false"
          >关 闭</el-button
        >
      </span>
    </el-dialog>

    <!-- HTML 面单（无 PDF 时用浏览器打印） -->
    <iframe
      v-if="!pdfUrl && currentWaybill"
      ref="htmlFrame"
      style="display: none"
      :srcdoc="currentWaybill"
      @load="onFrameLoaded"
      sandbox="allow-modals allow-same-origin allow-scripts"
    ></iframe>
  </div>
</template>

<script>
// 供应商发货子订单不分页、子订单修改、获取供应商快递、预约取件发货(无面单)、
// 电子面单寄件、查询物流轨迹、有面单取消、无面单取消、补打获取面单、
// 手动填写快递单号、小商品订单补发、查询小商品订单补发历史
import {
  getOrderItemSupAll,
  updateOrderItemSup,
  getSupplierAll,
  appointmentPic,
  electronicPic,
  getThirdExpress,
  electronicCan,
  appointmentCan,
  getByExpressNo,
  manuaFillExpress,
  createReship,
  getReshipList,
} from "@/api/supplier.js";
import axios from "axios";
import { getLodop } from "@/plugins/data/LodopFuncs";
import { getCookie } from "@/unit/cookie";
import * as pdfjsLib from "pdfjs-dist/legacy/build/pdf";

pdfjsLib.GlobalWorkerOptions.workerSrc =
  "//cdnjs.cloudflare.com/ajax/libs/pdf.js/2.16.105/pdf.worker.min.js";

const WAYBILL_PAGE_WIDTH = "76mm";
const WAYBILL_PAGE_HEIGHT = "130mm";

export default {
  name: "internal-details",
  components: {},
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    // 传整个订单对象
    myOrder: {
      type: Object,
      default: () => ({}),
    },
    // 供应商IDs
    supplierIds: {
      type: Array,
      default: () => [],
    },
    // 供应商列表
    formatSupplier: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      isClicked: false, //是否点击
      dialogVisible: this.visible,
      // 订单
      detailsData: this.myOrder,
      shipmentData: [], //供应商发货信息
      workDialogVisible: false,
      // 控制物流状态右侧弹框
      drawer: false,
      dialogVisibleFill: false, //手动填写面单弹框
      orderFillDeliverySn: "",
      orderFillSenderPhone: "", //发货人手机号
      dialogVisibleReship: false, //订单补发弹框
      reshipSubmitting: false,
      reshipForm: {
        shipmentMode: "APPOINTMENT", // APPOINTMENT | ELECTRONIC | MANUAL
        reason: "",
        expressNo: "",
      },
      dialogVisibleReshipList: false, //订单补发历史弹框
      reshipListLoading: false,
      reshipListData: [],
      // 物流轨迹
      preDetail: {},
      currentWaybill: "", //html内容
      htmlContentWithStyles: "", //包含打印样式的html内容
      pdfUrl: "", // 原始 pdf 地址
      previewSrc: "", // 预览用地址（优先 blob，同源可直接 print）
      pdfBlobUrl: "", // blob URL，关闭时释放
      pdfPreviewVisible: false, //浏览器面单预览
      pdfPrintLoading: false,
      pdfLoaded: false, //状态管理
      contentIsPdf: true, //类型
      pendingPrint: false, // HTML 加载完成后自动打印
      isPrinting: false, //
      statusMessage: "", //
      loading: false,
      expressCompanyEnum: "", //快递名称
      expressOptions: [], //供应商关联快递账号
      multipleSelection: [], //多选
      isHtmlLoaded: false, //HTML是否已加载
      // 创建供应商公司映射表，提高查找效率
      supplierMap: {},
      ids: "", //供应商ID
      htmlPrintOptions: {
        width: WAYBILL_PAGE_WIDTH,
        height: WAYBILL_PAGE_HEIGHT,
        margin: "0mm",
      },
    };
  },
  watch: {
    visible(newValue) {
      this.dialogVisible = newValue;
      this.detailsData = this.myOrder;
      this.orderFillDeliverySn = "";
      this.expressCompanyEnum = "";
      this.multipleSelection = [];
      this.orderFillSenderPhone = "";
      this.dialogVisibleReship = false;
      this.reshipSubmitting = false;
      this.resetReshipForm();
      this.dialogVisibleReshipList = false;
      this.reshipListLoading = false;
      this.reshipListData = [];
      this.currentWaybill = "";
      this.pdfUrl = "";
      this.previewSrc = "";
      this.revokePdfBlobUrl();
      this.pdfPreviewVisible = false;
      this.pdfLoaded = false;
      this.pendingPrint = false;
      // 如果弹框关闭所有数据都要清空
      if (!newValue) {
        this.$emit("refreshOrder", true);
      } else {
        setTimeout(() => {
          this.ids = this.supplierIds ? this.supplierIds.join() : "";
          // 获取供应商发货信息
          this.getShipmentList(this.detailsData.paySn, this.ids);
          this.supplierMap = this.createSupplierMap(this.formatSupplier);
          // 获取供应商相关快递账号显示
          this.getSupplierList(this.detailsData.supplierId);
          // 如果快递单号为空的情况禁止调用发货按钮
        }, 1000);
        // this.getExpress(this.detailsData.orderSn)
        console.log(this.detailsData);
      }
    },
  },
  created() {},
  mounted() {},
  methods: {
    async getShipmentList(paySn, ids) {
      const { data: res } = await getOrderItemSupAll({
        paySn: paySn || "",
        ids: ids,
        status: 0,
      });
      // console.log("ll-----", res, orderData);
      if (res.code === 200) {
        this.shipmentData = res.data;
      }
    },
    // 格式化供应商公司列
    formatSupplierName(row, column) {
      // 从映射表中查找对应的物流公司名称
      return this.supplierMap[row.supplierId] || row.supplierId;
    },
    // 创建供应商映射表（label -> value）
    createSupplierMap(supplier) {
      return supplier.reduce((map, company) => {
        map[company.id] = company.supplierName;
        return map;
      }, {});
    },
    async getSupplierList(suppId) {
      const { data: res } = await getSupplierAll({
        supplierId: suppId,
      });
      // console.log("ll-----", res, orderData);
      if (res.code === 200) {
        this.expressOptions = res.data;
      }
    },
    // 多选发货
    handleSelectionChange(val) {
      this.multipleSelection = val;
      console.log("val", val);
    },
    // 有面单
    handleElectronicConfirm() {
      if (!this.validateForm()) {
        return;
      }
      if (this.isClicked) {
        return;
      }
      this.isClicked = true;
      let data = {
        expressCompanyEnum: this.expressCompanyEnum,
        omsOrderSmallItems: this.multipleSelection,
      };
      console.log("data", data);
      electronicPic(data)
        .then((res) => {
          if (res.data.code === 200) {
            this.$message.success(
              "快递单号生成成功，请确保货物已打包封装无误！",
            );
            this.expressCompanyEnum = "";
            this.multipleSelection = [];
            // 从HTML中提取PDF URL
            this.extractPdfUrlFromHtml(res.data.data.printTemplate);
            // 获取供应商发货信息
            this.getShipmentList(this.detailsData.paySn, this.ids);
          } else {
            this.$message.error(`${res.data.message}`);
          }
          this.isClicked = false;
        })
        .catch(() => {
          this.isClicked = false;
        });
    },
    // 无面单
    handleAppointmentConfirm() {
      if (!this.validateForm()) {
        return;
      }
      if (this.isClicked) {
        return;
      }
      this.isClicked = true;
      let data = {
        expressCompanyEnum: this.expressCompanyEnum,
        omsOrderSmallItems: this.multipleSelection,
      };
      appointmentPic(data)
        .then((res) => {
          if (res.data.code === 200) {
            this.$message.success(
              "已预约快递上门取件，请确保货物已打包封装无误！",
            );
            this.expressCompanyEnum = "";
            this.multipleSelection = [];
            if (this.$refs.multipleTable) {
              this.$refs.multipleTable.clearSelection();
            }
            // 获取供应商发货信息（deliveryType=0，操作列展示取消寄件）
            this.getShipmentList(this.detailsData.paySn, this.ids);
          } else {
            this.$message.error(`${res.data.message}`);
          }
          this.isClicked = false;
        })
        .catch(() => {
          this.isClicked = false;
        });
    },
    // 通过快递单号获取物流轨迹
    async expressDetail(mailNo) {
      this.drawer = true;
      this.preDetail = {};
      const { data: res } = await getThirdExpress(mailNo);
      if (res.code === 200 && res.data != null) {
        let arr = res.data.length;
        if (arr != 0) {
          this.preDetail = res.data;
        } else {
          this.preDetail = [];
        }
      } else {
        this.$message.error(`${res.message}`);
      }
    },
    // 手动填写订单
    handleEditFill() {
      this.dialogVisibleFill = true;
    },
    handleDialogFill() {
      if (!this.validateForm()) {
        return;
      }
      if (this.orderFillDeliverySn) {
        let data = {
          expressCompany: this.expressCompanyEnum,
          expressNo: this.orderFillDeliverySn,
          senderPhone: this.orderFillSenderPhone,
          omsOrderSmallItems: this.multipleSelection,
        };
        manuaFillExpress(data)
          .then((res) => {
            if (res.data.code === 200) {
              this.orderFillDeliverySn = "";
              this.expressCompanyEnum = "";
              this.multipleSelection = [];
              this.orderFillSenderPhone = "";
              this.dialogVisibleFill = false;
              this.$message.success("手动填写单号成功");
              // 获取供应商发货信息
              this.getShipmentList(this.detailsData.paySn, this.ids);
            } else {
              this.$message.error(`${res.data.message}`);
            }
          })
          .catch(() => {});
      } else {
        this.$message.error("手动填写单号不能为空！");
      }
    },
    resetReshipForm() {
      this.reshipForm = {
        shipmentMode: "APPOINTMENT",
        reason: "",
        expressNo: "",
      };
    },
    // 打开订单补发弹框
    handleReship() {
      if (!this.expressCompanyEnum) {
        this.$message.error("请选择发货快递类型！");
        return;
      }
      if (!this.multipleSelection.length) {
        this.$message.error("请先勾选要补发的商品！");
        return;
      }
      this.resetReshipForm();
      this.dialogVisibleReship = true;
    },
    // 查询订单补发历史
    async handleReshipList() {
      const orderSn =
        (this.multipleSelection[0] && this.multipleSelection[0].orderSn) ||
        this.detailsData.orderSn ||
        (this.shipmentData[0] && this.shipmentData[0].orderSn) ||
        "";
      if (!orderSn) {
        this.$message.error("缺少订单编号，无法查询补发历史");
        return;
      }
      this.dialogVisibleReshipList = true;
      this.reshipListLoading = true;
      this.reshipListData = [];
      try {
        const { data: res } = await getReshipList(orderSn);
        if (res.code === 200) {
          this.reshipListData = Array.isArray(res.data) ? res.data : [];
          if (!this.reshipListData.length) {
            this.$message.info("暂无补发历史");
          }
        } else {
          this.$message.error(res.message || "查询补发历史失败");
        }
      } catch (err) {
        this.$message.error(
          (err && err.message) || "查询补发历史失败，请稍后重试",
        );
      } finally {
        this.reshipListLoading = false;
      }
    },
    getReshipExpressNo(row) {
      if (!row) return "";
      return (
        (row.express && row.express.expressNo) ||
        row.expressNo ||
        ""
      );
    },
    getReshipPrintTemplate(row) {
      if (!row) return "";
      return (
        (row.express && row.express.printTemplate) ||
        row.printTemplate ||
        ""
      );
    },
    formatShipmentMode(mode) {
      switch (mode) {
        case "APPOINTMENT":
          return "无面单";
        case "ELECTRONIC":
          return "电子面单";
        case "MANUAL":
          return "手动填写";
        default:
          return mode || "-";
      }
    },
    formatCreateStatus(status) {
      const map = {
        0: "处理中",
        1: "成功",
        2: "失败",
      };
      if (status === null || status === undefined || status === "") {
        return "-";
      }
      return map[status] != null ? map[status] : String(status);
    },
    // 提交订单补发
    handleReshipConfirm() {
      const { shipmentMode, reason, expressNo } = this.reshipForm;
      if (!shipmentMode) {
        this.$message.error("请选择发货方式！");
        return;
      }
      if (!reason || !reason.trim()) {
        this.$message.error("请填写补发原因！");
        return;
      }
      if (shipmentMode === "MANUAL" && !(expressNo && expressNo.trim())) {
        this.$message.error("请填写快递单号！");
        return;
      }
      if (!this.expressCompanyEnum) {
        this.$message.error("请选择发货快递类型！");
        return;
      }
      if (!this.multipleSelection.length) {
        this.$message.error("请先勾选要补发的商品！");
        return;
      }

      const orderSn =
        this.multipleSelection[0].orderSn ||
        this.detailsData.orderSn ||
        "";
      if (!orderSn) {
        this.$message.error("缺少订单编号，无法补发");
        return;
      }

      const payload = {
        expressCompany: this.expressCompanyEnum,
        expressNo: shipmentMode === "MANUAL" ? expressNo.trim() : "",
        items: this.multipleSelection.map((row) => ({
          orderItemId: row.id,
          reshipQuantity: row.quantity || 1,
        })),
        operatorId: Number(getCookie("userId")) || 0,
        operatorName: getCookie("nickname") || getCookie("username") || "",
        orderSn,
        reason: reason.trim(),
        requestNo: `RS${Date.now()}${Math.floor(Math.random() * 1000)}`,
        shipmentMode,
      };

      this.reshipSubmitting = true;
      createReship(payload)
        .then(async (res) => {
          if (res.data.code === 200) {
            this.$message.success("订单补发成功");
            this.dialogVisibleReship = false;
            this.resetReshipForm();
            this.expressCompanyEnum = "";
            this.multipleSelection = [];
            if (this.$refs.multipleTable) {
              this.$refs.multipleTable.clearSelection();
            }
            // 补发成功后重新拉取当前发货商品列表
            this.ids = this.supplierIds ? this.supplierIds.join() : this.ids;
            await this.getShipmentList(this.detailsData.paySn, this.ids);

            const data = res.data.data || {};
            const printTemplate =
              data.printTemplate ||
              (data.express && data.express.printTemplate) ||
              "";
            if (shipmentMode === "ELECTRONIC" && printTemplate) {
              this.extractPdfUrlFromHtml(printTemplate);
            }
          } else {
            this.$message.error(res.data.message || "订单补发失败");
          }
        })
        .catch((err) => {
          this.$message.error(
            (err && err.message) || "订单补发失败，请稍后重试",
          );
        })
        .finally(() => {
          this.reshipSubmitting = false;
        });
    },
    // 补打面单：useLodop=true 直接 Lodop 打印；false 打开预览弹框
    async handleEdit(row, useLodop = true) {
      this.currentWaybill = "";
      this.pdfUrl = "";
      this.previewSrc = "";
      this.revokePdfBlobUrl();
      this.pdfPreviewVisible = false;
      this.pdfLoaded = false;
      this.pendingPrint = false;
      this.loading = true;
      try {
        const { data: res } = await getByExpressNo(row.deliverySn);
        if (res.code === 200) {
          this.currentWaybill = res.data.printTemplate || "";
          console.log("print11111", res.data, "useLodop=", useLodop);
          this.printWaybillTemplate(this.currentWaybill, useLodop);
        } else {
          this.$message.error(res.message || "获取面单失败");
        }
      } catch (error) {
        this.$message.error(error.message || "获取面单失败");
      } finally {
        this.loading = false;
      }
    },
    // 处理HTML加载完成事件
    onFrameLoaded() {
      this.isHtmlLoaded = true;
      console.log("html内容加载完成");
      if (this.pendingPrint && !this.pdfUrl) {
        this.pendingPrint = false;
        this.printHtml();
      }
    },
    /** 部署站点 origin（与 axios baseURL 一致） */
    getResourceOrigin() {
      const base =
        (axios.defaults && axios.defaults.baseURL) ||
        (this.$axios && this.$axios.defaults.baseURL) ||
        "";
      try {
        return new URL(base).origin;
      } catch (e) {
        return window.location.origin;
      }
    },
    /**
     * 从面单 HTML 原文提取 PDF 地址（避免 innerHTML 相对路径被解析到前端页）
     */
    findPdfSrcInHtml(html) {
      if (!html) return "";
      const patterns = [
        /(data:application\/pdf;base64,[A-Za-z0-9+/=]+)/i,
        /class=["'][^"']*kdnPDFLodoopSrc[^"']*["'][^>]*src=["']([^"']+)["']/i,
        /src=["']([^"']+)["'][^>]*class=["'][^"']*kdnPDFLodoopSrc[^"']*["']/i,
        /<embed[^>]+src=["']([^"']+\.pdf[^"']*)["']/i,
        /<iframe[^>]+src=["']([^"']+\.pdf[^"']*)["']/i,
        /href=["']([^"']+\.pdf[^"']*)["']/i,
        /(https?:\/\/[^\s"'<>]+\/electron[^\s"'<>]*\.pdf)/i,
        /(https?:\/\/[^\s"'<>]*kdniao[^\s"'<>]+\.pdf)/i,
        /(\/electron[^\s"'<>]*\.pdf)/i,
      ];
      for (let i = 0; i < patterns.length; i++) {
        const match = html.match(patterns[i]);
        if (match && match[1]) {
          return match[1].trim();
        }
      }
      return "";
    },
    /** 解析为浏览器/Lodop 可用的 PDF 地址 */
    resolveWaybillPdfUrl(rawUrl) {
      if (!rawUrl) return "";
      let url = String(rawUrl).trim().replace(/&amp;/g, "&");
      if (/^data:application\/pdf;base64,/i.test(url)) {
        return url;
      }
      if (url.startsWith("//")) {
        url = `https:${url}`;
      }
      if (/^http:\/\//i.test(url)) {
        url = url.replace(/^http:\/\//i, "https://");
      }
      url = url.replace(
        /https?:\/\/resource\.kdniao\.com/i,
        "https://resources.kdniao.com",
      );

      // 快递鸟：保留绝对 https（Lodop 直拉不受 CORS）；浏览器拉取另走 getFetchablePdfUrl
      if (/resources?\.kdniao\.com|api\.kdniao\.com/i.test(url)) {
        try {
          return new URL(url, window.location.origin).href;
        } catch (e) {
          return url;
        }
      }

      const electronMatch = url.match(/\/electron[^\s"'?]*/i);
      if (electronMatch) {
        return `https://resources.kdniao.com${electronMatch[0]}`;
      }

      if (/^https?:\/\//i.test(url)) {
        return url;
      }

      if (url.startsWith("/")) {
        if (url.startsWith("/pdf-proxy")) return url;
        return `${this.getResourceOrigin()}${url}`;
      }

      if (/\.pdf$/i.test(url) && !url.includes("/")) {
        return `https://resources.kdniao.com/electron/${url}`;
      }

      return "";
    },
    /** Lodop / 展示用的绝对 https PDF 地址 */
    toAbsolutePdfUrl(pdfUrl) {
      if (!pdfUrl) return "";
      if (pdfUrl.startsWith("/pdf-proxy")) {
        return `https://resources.kdniao.com${pdfUrl.replace(/^\/pdf-proxy/, "")}`;
      }
      if (/^https?:\/\//i.test(pdfUrl)) {
        return pdfUrl
          .replace(/^http:\/\//i, "https://")
          .replace(
            /https:\/\/resource\.kdniao\.com/i,
            "https://resources.kdniao.com",
          );
      }
      const electronMatch = String(pdfUrl).match(/\/electron\/.+/i);
      if (electronMatch) {
        return `https://resources.kdniao.com${electronMatch[0]}`;
      }
      return pdfUrl;
    },
    revokePdfBlobUrl() {
      if (this.pdfBlobUrl) {
        URL.revokeObjectURL(this.pdfBlobUrl);
        this.pdfBlobUrl = "";
      }
    },
    /**
     * 拉取 PDF 为同源 blob
     */
    async loadPdfAsBlobUrl(pdfUrl) {
      const fetchUrl = this.getFetchablePdfUrl(pdfUrl);
      const response = await fetch(fetchUrl, {
        mode: "cors",
        credentials: "omit",
      });
      if (!response.ok) {
        throw new Error(`PDF 请求失败: ${response.status}`);
      }
      const blob = await response.blob();
      if (!blob || blob.size === 0) {
        throw new Error("PDF 内容为空");
      }
      const pdfBlob =
        blob.type && blob.type.includes("pdf")
          ? blob
          : new Blob([blob], { type: "application/pdf" });
      this.revokePdfBlobUrl();
      this.pdfBlobUrl = URL.createObjectURL(pdfBlob);
      return this.pdfBlobUrl;
    },
    /**
     * 电子面单打印
     * @param {string} textHtml 面单 HTML
     * @param {boolean} useLodop true=Lodop 直接打印；false=打开面单预览弹框
     */
    async printWaybillTemplate(textHtml, useLodop = true) {
      if (!textHtml) {
        this.$message.error("面单内容为空");
        return;
      }
      this.currentWaybill = textHtml;
      const rawSrc = this.findPdfSrcInHtml(textHtml);
      const pdfUrl = this.resolveWaybillPdfUrl(rawSrc);
      console.log("printWaybillTemplate", { rawSrc, pdfUrl, useLodop });

      if (pdfUrl) {
        this.pdfUrl = pdfUrl;
        this.contentIsPdf = true;
        if (useLodop) {
          this.pdfPreviewVisible = false;
          this.printWithLodopPdf(pdfUrl);
        } else {
          await this.openWaybillPreviewDialog(pdfUrl);
        }
        return;
      }

      this.pdfUrl = "";
      this.previewSrc = "";
      this.contentIsPdf = false;
      this.pdfPreviewVisible = false;
      this.printWithLodopHtml(textHtml);
    },
    /**
     * 打开面单预览弹框：嵌入浏览器 PDF 查看器（与截图一致）
     * 优先 https 绝对地址，便于 Chrome 内置工具栏（缩放/下载/打印）
     */
    async openWaybillPreviewDialog(pdfUrl) {
      const url = pdfUrl || this.pdfUrl;
      if (!url) {
        this.$message.error("没有可预览的面单");
        return false;
      }
      const absUrl = this.toAbsolutePdfUrl(url);
      this.pdfUrl = absUrl || url;
      // 直接用 https 地址嵌入，展示浏览器原生 PDF 查看器
      this.previewSrc = absUrl || url;
      this.pdfPreviewVisible = true;
      return true;
    },
    openPdfInNewTab() {
      const url =
        this.toAbsolutePdfUrl(this.pdfUrl) ||
        (this.previewSrc && !String(this.previewSrc).startsWith("blob:")
          ? this.previewSrc
          : "") ||
        this.previewSrc;
      if (!url) return;
      window.open(url, "_blank");
    },
    /**
     * 浏览器可 fetch 的地址：快递鸟一律走同源 /pdf-proxy（避免 CORS）
     * 生产若未配 nginx 代理会 404，Lodop 路径会回退 URL 直打
     */
    getFetchablePdfUrl(pdfUrl) {
      if (!pdfUrl) return "";
      if (
        pdfUrl.startsWith("/pdf-proxy") ||
        pdfUrl.startsWith("blob:") ||
        pdfUrl.startsWith("data:")
      ) {
        return pdfUrl;
      }
      const abs = this.toAbsolutePdfUrl(pdfUrl);
      if (/resources?\.kdniao\.com|api\.kdniao\.com/i.test(abs)) {
        try {
          const u = new URL(abs, window.location.origin);
          return `/pdf-proxy${u.pathname}${u.search}`;
        } catch (e) {
          console.warn("getFetchablePdfUrl 解析失败", pdfUrl, e);
        }
      }
      if (pdfUrl.startsWith("/") && typeof window !== "undefined") {
        return `${window.location.origin}${pdfUrl}`;
      }
      return pdfUrl;
    },
    /** data:application/pdf;base64,... → ArrayBuffer */
    pdfDataUrlToArrayBuffer(dataUrl) {
      const m = String(dataUrl).match(
        /^data:application\/pdf;base64,(.+)$/i,
      );
      if (!m) return null;
      const binary = atob(m[1]);
      const bytes = new Uint8Array(binary.length);
      for (let i = 0; i < binary.length; i++) {
        bytes[i] = binary.charCodeAt(i);
      }
      return bytes.buffer;
    },
    /** 拉取 PDF 二进制（仅同源 /pdf-proxy 或 data URL，避免 CORS） */
    async fetchPdfArrayBuffer(pdfUrl) {
      if (!pdfUrl) {
        throw new Error("PDF 地址为空");
      }
      const fromData = this.pdfDataUrlToArrayBuffer(pdfUrl);
      if (fromData) {
        return fromData;
      }

      const candidates = [];
      const proxyUrl = this.getFetchablePdfUrl(pdfUrl);
      if (proxyUrl) candidates.push(proxyUrl);
      // 不要把跨域绝对地址放进候选：必然 CORS 失败，只徒增报错

      let lastError = null;
      const seen = new Set();
      for (const fetchUrl of candidates) {
        if (!fetchUrl || seen.has(fetchUrl)) continue;
        seen.add(fetchUrl);
        try {
          const response = await fetch(fetchUrl, {
            mode: "cors",
            credentials: "omit",
          });
          if (!response.ok) {
            throw new Error(`PDF 请求失败: ${response.status}`);
          }
          const contentType = (
            response.headers.get("content-type") || ""
          ).toLowerCase();
          // 线上未配 nginx 代理时，/pdf-proxy 常回落到 SPA 的 index.html
          if (contentType.includes("text/html")) {
            throw new Error(
              "面单代理未生效（返回了 HTML）。本地请用 npm run serve；线上请配置 /pdf-proxy",
            );
          }
          const buffer = await response.arrayBuffer();
          if (!buffer || buffer.byteLength < 100) {
            throw new Error("PDF 内容为空或无效");
          }
          const headBytes = new Uint8Array(buffer.slice(0, 5));
          const head = String.fromCharCode(
            headBytes[0],
            headBytes[1],
            headBytes[2],
            headBytes[3],
            headBytes[4],
          );
          // SPA 回退常见：Content-Type 不准，但内容是 <!DOC / <html
          if (head === "%PDF-") {
            return buffer;
          }
          const asText = String.fromCharCode(
            ...new Uint8Array(buffer.slice(0, 32)),
          ).toLowerCase();
          if (asText.includes("<!doctype") || asText.includes("<html")) {
            throw new Error(
              "面单代理未生效（返回了 HTML）。请配置站点 nginx /pdf-proxy，或本地使用 npm run serve",
            );
          }
          throw new Error("下载内容不是合法 PDF（代理可能未配置）");
        } catch (e) {
          lastError = e;
          console.warn("拉取 PDF 失败", fetchUrl, e);
        }
      }
      throw lastError || new Error("无法下载面单 PDF（跨域或代理不可用）");
    },
    /** 电子面单 Lodop 纸张与分页设置（避免内容被自动拆成两页） */
    setupWaybillLodopPage(LODOP) {
      LODOP.PRINT_INIT("电子面单");
      LODOP.SET_PRINT_PAGESIZE(1, WAYBILL_PAGE_WIDTH, WAYBILL_PAGE_HEIGHT);
      LODOP.SET_PRINT_MODE("POS_BASEON_PAPER", true);
      LODOP.SET_PRINT_MODE("AUTO_DIVIDE_PAGE", 0);
      LODOP.SET_PRINT_COPIES(1);
    },
    /** 判断栅格化图片是否接近空白（过滤 PDF 尾部空页） */
    isBlankImageDataUrl(dataUrl) {
      return new Promise((resolve) => {
        const img = new Image();
        img.onload = () => {
          const sampleW = Math.min(img.width, 240);
          const sampleH = Math.min(img.height, 240);
          const canvas = document.createElement("canvas");
          canvas.width = sampleW;
          canvas.height = sampleH;
          const ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0, sampleW, sampleH);
          const pixels = ctx.getImageData(0, 0, sampleW, sampleH).data;
          let inkPixels = 0;
          for (let i = 0; i < pixels.length; i += 4) {
            if (pixels[i] < 248 || pixels[i + 1] < 248 || pixels[i + 2] < 248) {
              inkPixels += 1;
            }
          }
          resolve(inkPixels < 80);
        };
        img.onerror = () => resolve(true);
        img.src = dataUrl;
      });
    },
    async filterPrintableImages(images) {
      if (!Array.isArray(images) || !images.length) {
        return [];
      }
      const kept = [];
      for (const img of images) {
        const blank = await this.isBlankImageDataUrl(img);
        if (!blank) {
          kept.push(img);
        }
      }
      return kept.length ? kept : [images[0]];
    },
    /** Lodop 直打 PDF（与浏览器预览一致，优先尝试） */
    printLodopPdfDirect(LODOP, absUrl) {
      if (!LODOP || !absUrl) {
        return false;
      }
      this.setupWaybillLodopPage(LODOP);
      LODOP.ADD_PRINT_PDF(0, 0, "100%", "100%", absUrl);
      LODOP.SET_PRINT_STYLEA(0, "PDFScalMode", 1);
      LODOP.PRINT();
      return true;
    },
    /** 将面单图片发送到 Lodop 打印 */
    printLodopWaybillImages(LODOP, images) {
      if (!LODOP || !images || !images.length) {
        return false;
      }
      this.setupWaybillLodopPage(LODOP);
      images.forEach((img, index) => {
        if (index > 0) {
          LODOP.NewPage();
        }
        LODOP.ADD_PRINT_IMAGE(
          0,
          0,
          WAYBILL_PAGE_WIDTH,
          WAYBILL_PAGE_HEIGHT,
          img,
        );
        LODOP.SET_PRINT_STYLEA(0, "Stretch", 1);
      });
      LODOP.PRINT();
      return true;
    },
    /**
     * pdf.js 渲染每一页为 PNG（不依赖 ADD_PRINT_PDF 顶级授权）
     */
    async renderPdfPagesToImages(arrayBuffer, scale) {
      const loadingTask = pdfjsLib.getDocument({ data: arrayBuffer });
      const pdf = await loadingTask.promise;
      const images = [];
      for (let i = 1; i <= pdf.numPages; i++) {
        const page = await pdf.getPage(i);
        const baseViewport = page.getViewport({ scale: 1 });
        const targetScale =
          scale ||
          Math.min(2, Math.max(1.2, 960 / Math.max(baseViewport.width, 1)));
        const viewport = page.getViewport({ scale: targetScale });
        const canvas = document.createElement("canvas");
        canvas.width = viewport.width;
        canvas.height = viewport.height;
        const ctx = canvas.getContext("2d");
        ctx.fillStyle = "#ffffff";
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        await page.render({
          canvasContext: ctx,
          viewport,
        }).promise;
        images.push(canvas.toDataURL("image/png"));
      }
      return images;
    },
    /**
     * 用 Lodop 本机拉 PDF 并导出为 PNG（不走浏览器 fetch，绕过 CORS / 未配 /pdf-proxy）
     * 依赖控件能渲染该 PDF（试用或已授权）；导出后再用 ADD_PRINT_IMAGE 正式打印
     */
    lodopAwait(LODOP, run) {
      return new Promise((resolve) => {
        if (LODOP.CVERSION) {
          LODOP.On_Return = (taskId, value) => resolve(value);
        }
        const ret = run();
        if (!LODOP.CVERSION) {
          resolve(ret);
        }
      });
    },
    async rasterizePdfViaLodop(LODOP, absUrl) {
      if (!LODOP || !absUrl) {
        throw new Error("Lodop 或 PDF 地址无效");
      }
      const tmpPng = `C:\\Users\\Public\\kdniao_waybill_${Date.now()}.png`;
      LODOP.PRINT_INIT("电子面单栅格化");
      LODOP.SET_PRINT_PAGESIZE(1, WAYBILL_PAGE_WIDTH, WAYBILL_PAGE_HEIGHT);
      LODOP.ADD_PRINT_PDF(0, 0, "100%", "100%", absUrl);
      LODOP.SET_PRINT_STYLEA(0, "PDFScalMode", 1);
      LODOP.SET_SAVE_MODE("FILE_PROMPT", 0);

      const saved = await this.lodopAwait(LODOP, () => LODOP.SAVE_TO_FILE(tmpPng));
      if (!saved) {
        throw new Error("Lodop 导出面单图片失败");
      }

      const raw = await this.lodopAwait(LODOP, () =>
        LODOP.FORMAT("FILE:EncodeBase64", tmpPng),
      );
      if (!raw || typeof raw !== "string" || raw.length < 32) {
        throw new Error("Lodop 读取导出图片失败");
      }
      const dataUrl = raw.startsWith("data:")
        ? raw
        : `data:image/png;base64,${raw}`;
      return [dataUrl];
    },
    /**
     * C-Lodop 打印面单 PDF
     * 1）同源 /pdf-proxy → pdf.js 转图片 → ADD_PRINT_IMAGE
     * 2）Lodop 本机拉 PDF 导出 PNG → ADD_PRINT_IMAGE（不依赖浏览器代理）
     * 3）ADD_PRINT_PDF 直打 / 打开浏览器预览
     */
    async printWithLodopPdf(pdfUrl) {
      const url = pdfUrl || this.pdfUrl;
      if (!url) {
        this.$message.error("没有可打印的面单");
        return false;
      }
      const absUrl = this.toAbsolutePdfUrl(url);

      let LODOP = null;
      try {
        LODOP = getLodop();
      } catch (e) {
        console.warn("getLodop 异常", e);
      }
      if (!LODOP) {
        this.$message.warning("未检测到 C-Lodop，打开浏览器预览");
        return this.openWaybillPreviewDialog(absUrl || url);
      }

      this.pdfPrintLoading = true;
      try {
        let images = null;
        try {
          const buffer = await this.fetchPdfArrayBuffer(url);
          images = await this.renderPdfPagesToImages(buffer);
        } catch (fetchErr) {
          console.warn("浏览器拉 PDF 转图片失败，改用 Lodop 本机栅格化", fetchErr);
          images = await this.rasterizePdfViaLodop(LODOP, absUrl);
        }
        images = await this.filterPrintableImages(images || []);
        if (images.length) {
          this.printLodopWaybillImages(LODOP, images);
          this.$message.success("已发送到打印机");
          return true;
        }

        console.warn("转图片无有效页，尝试 Lodop PDF 直打");
        this.printLodopPdfDirect(LODOP, absUrl);
        this.$message.success("已发送到打印机");
        return true;
      } catch (e) {
        console.warn("转图片打印失败，打开浏览器面单预览", e);
        this.$message.warning(
          "自动转图片失败，已打开预览，请用弹框内「打印」或 PDF 工具栏打印",
        );
        await this.openWaybillPreviewDialog(absUrl || url);
        return false;
      } finally {
        this.pdfPrintLoading = false;
      }
    },
    /**
     * 浏览器系统打印：仅同源 blob iframe，不跳转新窗口
     */
    async printPdfByBrowserDialog(pdfUrl) {
      const url = pdfUrl || this.pdfUrl;
      if (!url) {
        this.$message.error("没有可打印的面单");
        return false;
      }
      this.pdfPrintLoading = true;
      let iframe = null;
      try {
        // 必须经 /pdf-proxy 拉成 blob，跨域地址无法 print
        const blobUrl = await this.loadPdfAsBlobUrl(url);

        iframe = document.createElement("iframe");
        iframe.setAttribute("title", "waybill-browser-print");
        iframe.style.cssText =
          "position:fixed;left:0;top:0;width:1px;height:1px;border:0;opacity:0;pointer-events:none;";
        document.body.appendChild(iframe);

        await new Promise((resolve, reject) => {
          let done = false;
          const finish = (ok) => {
            if (done) return;
            done = true;
            ok ? resolve() : reject(new Error("PDF 加载失败"));
          };
          iframe.onload = () => finish(true);
          iframe.onerror = () => finish(false);
          iframe.src = blobUrl;
          setTimeout(() => finish(true), 3000);
        });

        const win = iframe.contentWindow;
        if (!win) {
          throw new Error("无法访问打印窗口");
        }
        win.focus();
        win.print();
        this.$message.success("已打开系统打印对话框");
        return true;
      } catch (e) {
        console.error("浏览器打印失败", e);
        // 最后兜底：新窗口打开绝对地址，用户可手动 Ctrl+P（不依赖 CORS 读内容）
        const openUrl = this.toAbsolutePdfUrl(url);
        if (openUrl && /^https:\/\//i.test(openUrl)) {
          window.open(openUrl, "_blank");
          this.$message.info(
            "无法同源加载面单，已在新窗口打开，请使用浏览器打印（Ctrl+P）；或改用「补打面单」",
          );
          return true;
        }
        this.$message.error(
          "浏览器打印需要同源加载面单。本地请确认 /pdf-proxy；线上请配置网关 /pdf-proxy 或使用「补打面单」",
        );
        return false;
      } finally {
        this.pdfPrintLoading = false;
        if (iframe) {
      setTimeout(() => {
            if (iframe.parentNode) {
              iframe.parentNode.removeChild(iframe);
            }
          }, 60000);
        }
      }
    },
    /** 无 PDF 时用 Lodop 打印 HTML 面单模板 */
    printWithLodopHtml(htmlTemplate) {
      if (!htmlTemplate) {
        this.$message.error("没有可打印的面单内容");
        return false;
      }
      let LODOP = null;
      try {
        LODOP = getLodop();
      } catch (e) {
        console.warn("getLodop 异常", e);
      }
      if (!LODOP) {
        this.$message.error("请先安装并启动 C-Lodop 打印控件后再打印");
        return false;
      }
      try {
        this.setupWaybillLodopPage(LODOP);
        LODOP.ADD_PRINT_HTM(0, 0, "100%", "100%", htmlTemplate);
        LODOP.SET_PRINT_MODE("FULL_WIDTH_FOR_OVERFLOW", true);
        LODOP.SET_PRINT_MODE("FULL_HEIGHT_FOR_OVERFLOW", true);
        LODOP.PRINT();
        // LODOP.PREVIEW();
        this.$message.success("已发送到打印机");
        return true;
      } catch (e) {
        console.error("Lodop HTML 打印失败", e);
        this.$message.error(e.message || "Lodop 打印失败");
        return false;
      }
    },
    /**
     * 预览弹窗「打印」：浏览器系统打印（不走 Lodop）
     * 同源 blob 可 iframe.print；跨域则新窗口打开由用户打印
     */
    async printBrowserPdf() {
      const url = this.pdfUrl || this.previewSrc;
      if (!url) {
        this.$message.error("没有可打印的面单");
        return false;
      }
      this.pdfPrintLoading = true;
      try {
        // 已是同源 blob：直接打预览框里的 iframe
        if (
          this.previewSrc &&
          String(this.previewSrc).startsWith("blob:") &&
          this.$refs.pdfPreviewFrame
        ) {
          const win = this.$refs.pdfPreviewFrame.contentWindow;
          if (win) {
            win.focus();
            win.print();
            this.$message.success("已打开系统打印对话框");
            return true;
          }
        }

        // 尝试拉成同源 blob 再打印
        try {
          const blobUrl = await this.loadPdfAsBlobUrl(url);
          this.previewSrc = blobUrl;
          await this.$nextTick();
          await new Promise((r) => setTimeout(r, 400));
          const frame = this.$refs.pdfPreviewFrame;
          if (frame && frame.contentWindow) {
            frame.contentWindow.focus();
            frame.contentWindow.print();
            this.$message.success("已打开系统打印对话框");
            return true;
          }
        } catch (e) {
          console.warn("同源打印失败，改新窗口打开", e);
        }

        // 跨域兜底：新窗口打开，可用浏览器 PDF 工具栏打印或 Ctrl+P
        const openUrl = this.toAbsolutePdfUrl(url);
        window.open(openUrl, "_blank");
        this.$message.info(
          "已在新窗口打开面单，请点击 PDF 工具栏打印图标或按 Ctrl+P",
        );
        return true;
      } catch (e) {
        console.error("浏览器打印失败", e);
        this.$message.error(e.message || "浏览器打印失败");
        return false;
      } finally {
        this.pdfPrintLoading = false;
      }
    },
    onPdfPreviewClosed() {
      this.revokePdfBlobUrl();
      this.previewSrc = "";
    },
    // 兼容旧调用
    extractPdfUrlFromHtml(textHtml) {
      this.printWaybillTemplate(textHtml);
    },
    printWaybill() {
      if (this.currentWaybill) {
        this.printWaybillTemplate(this.currentWaybill);
        return;
      }
      if (this.pdfUrl) {
        this.printWithLodopPdf(this.pdfUrl);
        return;
      }
      this.$message.error("没有可打印的面单内容");
    },
    printPdf() {
      this.printWithLodopPdf(this.pdfUrl);
    },
    // 取消订单
    handleCancle(row) {
      this.$confirm("是否取消该商品订单寄件?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          const deliverySn = row.deliverySn || row.delivery_sn;
          if (!deliverySn) {
            this.$message.error("缺少快递单号，无法取消寄件");
            return;
          }
          let data = {
            deliverySn,
            orderSn: row.orderSn || row.order_sn,
          };
          const rawType =
            row.deliveryType !== undefined && row.deliveryType !== null
              ? row.deliveryType
              : row.delivery_type;
          const deliveryType = Number(rawType);
          const cancelReq =
            deliveryType === 1 ? electronicCan(data) : appointmentCan(data);
          cancelReq
            .then((res) => {
              if (res.data.code === 200) {
                this.$message.success(`${deliverySn}单号成功取消寄件！`);
                this.getShipmentList(this.detailsData.paySn, this.ids);
              } else {
                this.$message.error(`${res.data.message}`);
              }
            })
            .catch(() => {
              this.$message.error("取消寄件失败，请稍后重试");
            });
        })
        .catch(() => {
          // this.$message.info("已取消");
        });
    },
    /**
     * 预约上门(0)、电子面单(1)可取消寄件；手动填单(2)不可取消
     * 注意：deliveryType=0 是有效值，不能用 if (!deliveryType) 判断
     */
    canCancelShipment(row) {
      if (!row) return false;
      // 兼容 camelCase / snake_case
      const rawType =
        row.deliveryType !== undefined && row.deliveryType !== null
          ? row.deliveryType
          : row.delivery_type;
      // null/undefined/空串才算没值；0 表示预约上门，必须展示取消
      if (rawType === undefined || rawType === null || rawType === "") {
        return false;
      }
      const type = Number(rawType);
      if (type !== 0 && type !== 1) {
        return false;
      }
      const sn = row.deliverySn || row.delivery_sn;
      // 取消接口依赖快递单号；无单号时仍允许预约单展示按钮（点取消时再提示）
      if (type === 0) {
        return true;
      }
      return !!sn;
    },

    printHtml() {
      const htmlFrame = this.$refs.htmlFrame;
      const frameWindow =
        htmlFrame.contentWindow || htmlFrame.contentDocument.defaultView;
      console.log(
        "html111111",
        frameWindow,
        this.$refs.htmlFrame.contentWindow,
      );
      // this.$refs.htmlFrame.contentWindow.print();
      // 等待iframe加载完成
      // htmlFrame.onload = () => {
      // 设置打印样式
      const style = document.createElement("style");
      style.innerHTML = `
          @media print {
            @page {
              size: 76mm 130mm;
              margin: 0;
            }
            body {
              margin: 0;
              padding: 0;
            }
          }
        `;

      // 添加样式到iframe
      frameWindow.document.head.appendChild(style);

      // 检查内容是否超出一页
      setTimeout(() => {
        const body = frameWindow.document.body;
        const pageHeight = 130 * 3.78; // 130mm转换为像素 (1mm ≈ 3.78px)

        if (body.scrollHeight > pageHeight) {
          // 内容超出一页，计算缩放比例
          const scale = pageHeight / body.scrollHeight;

          // 应用缩放
          body.style.transform = `scale(${scale})`;
          body.style.transformOrigin = "top left";
          body.style.width = `${76 / scale}mm`;
        }

        // 执行打印
        frameWindow.print();
        this.isHtmlLoaded = false;
      }, 100);
      // };
    },
    // 刷新内容
    refreshContent() {
      if (this.pdfUrl) {
        this.pdfPreviewVisible = true;
      }
    },
    handlePrintStarted() {
      this.isPrinting = true;
    },
    handlePrintCompleted() {
      this.isPrinting = false;
    },
    handlePrintFailed(error) {
      this.isPrinting = false;
      this.$message.error(error || "打印失败");
    },
    // 关闭物流状态弹框
    handleClose(done) {
      this.drawer = false;
    },
    // 判断行是否可选（补发需可选已发货行；首次发货在 validateForm 里拦截已发货）
    isRowSelectable() {
        return true;
    },
    // 验证（首次发货：无面单 / 电子面单 / 手动填写）
    validateForm() {
      if (!this.expressCompanyEnum) {
        this.$message.error("请选择发货快递类型！");
        return false;
      }
      if (this.multipleSelection.length == 0) {
        this.$message.error("请选择发货商品！");
        return false;
      }
      if (this.multipleSelection.some((row) => row.deliverySn)) {
        this.$message.error("已发货商品请使用「订单补发」！");
        return false;
      }
      return true;
    },
    // 使用switch语句映射物流公司代码到中文名称
    getCompanyName(code) {
      switch (code) {
        case "ZTO":
          return "中通快递";
        case "STO":
          return "申通快递";
        case "YTO":
          return "圆通快递";
        case "YD":
          return "韵达快递";
        case "YZPY":
          return "邮政快递包裹";
        case "EMS":
          return "EMS";
        case "SF":
          return "顺丰速运";
        case "JD":
          return "京东快递";
        case "JDKY":
          return "京东快运";
        case "UC":
          return "优速快递";
        case "DBL":
          return "德邦快递";
        case "JTSD":
          return "极兔速递";
        case "CNSD":
          return "菜鸟速递";
        case "CNCY":
          return "菜鸟橙运";
        case "DNWL":
          return "丹鸟物流";
        default:
          return code; // 未知代码返回原码
      }
    },
  },
};
</script>

<style scoped lang="less">
/* 自定义打印样式 */
@media print {
  body * {
    visibility: hidden;
  }

  .waybill-preview,
  .waybill-preview * {
    visibility: visible;
  }

  .waybill-preview {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: auto;
    border: none;
  }
}
.internal-details {
  // 订单详情弹框
  /deep/ .order-dialog {
    height: 90vh;
    margin-top: 30px !important;
    .el-dialog__body {
      height: 85%;
      overflow: auto;
      padding: 0px 25px 30px;
    }
    .ship-radio {
      margin-bottom: 20px;
      p {
        font-weight: bold;
        font-size: 16px;
        margin-bottom: 20px;
      }
      .ship-btn {
        margin-top: 20px;
      }
    }
    .ship-table {
      p {
        font-weight: bold;
        font-size: 16px;
      }
    }
  }
  // 订单备注弹框
  /deep/ .custom-begin-dialog {
    height: 300px !important;
    margin-top: 200px !important;
    /deep/ .el-dialog__body {
      padding: 10px 25px 0;
      .el-input__inner {
        width: 230px;
      }
    }
  }
  .box-card {
    // height: calc(100vh - 90px);
    .order-tabs {
      // height: calc(100vh - 300px);
      margin-top: 20px;
    }
    .card-txt {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 10px;
      p {
        font-size: 16px;
        font-weight: 700;
        color: #303133;
      }
      .btn {
        margin-bottom: 5px;
      }
    }
    /deep/ .el-tabs--border-card {
      border: none;
      box-shadow: none;
    }
    /deep/ .el-descriptions__body {
      .el-descriptions__table {
        table-layout: auto !important;
      }
    }
  }
}

/* 如果你使用了scoped样式 */
/deep/ .el-image-viewer__wrapper {
  z-index: 9999 !important;
}
/deep/ .el-tabs__item {
  font-weight: 600;
}
/deep/ .el-descriptions .is-bordered .el-descriptions-item__cell {
  border: 1px solid #dcdfe6 !important;
  text-align: center;
}
/deep/ .el-table__fixed-right::before {
  content: none;
}
/deep/ .el-drawer__body {
  padding-left: 10px;
}
.label {
  margin-top: 20px;
}
.ellipsis {
  width: 200px; /* 设置一个最大宽度 */
  overflow: hidden; /* 超出部分隐藏 */
  white-space: nowrap; /* 文本不换行 */
  text-overflow: ellipsis; /* 超出部分显示省略号 */
}
.waybill-preview-frame {
  width: 100%;
  height: 75vh;
  border: 1px solid #e4e7ed;
  background: #525659;
  display: block;
}
.waybill-preview-empty {
  text-align: center;
  color: #909399;
  padding: 40px 0;
}
::v-deep .waybill-preview-dialog .el-dialog__body {
  padding: 8px 12px;
}
.reship-empty {
  margin: 8px 0 0;
  color: #909399;
  font-size: 13px;
}
</style>
